/*
* Service worker registration for offline mode
*/

export const init = () => {
    const SW_URL = '/sw.js';

    if (!('serviceWorker' in navigator)) return;

    function tryRegister() {
        // Skip if inside an iframe (often sandboxed/opaque origins)
        if (window.top !== window.self) {
            console.warn('[SW] Skipping: running inside an iframe.');
            return;
        }

        // Must be a secure context (HTTPS or localhost)
        if (!window.isSecureContext) {
            console.warn('[SW] Skipping: not a secure context.');
            return;
        }

        // Same-origin sanity check
        const swOrigin = new URL(SW_URL, location.href).origin;
        if (swOrigin !== location.origin) {
            console.warn('[SW] Skipping: Service Worker must be same-origin. Got', swOrigin, 'expected', location.origin);
            return;
        }

        // Defer if the document is being prerendered
        if (document.visibilityState === 'prerender' || (('prerendering' in document) && document.prerendering)) {
            const onVisible = () => {
                document.removeEventListener('visibilitychange', onVisible);
                tryRegister();
            };
            document.addEventListener('visibilitychange', onVisible, { once: true });
            console.log('[SW] Deferred until visible.');
            return;
        }

        // Register
        navigator.serviceWorker.register(SW_URL, { scope: '/' })
            .then(async (reg) => {
                console.log('[SW] registered at', reg.scope);
                // Warm current page
                const ready = await navigator.serviceWorker.ready;
                ready.active?.postMessage({ type: 'WARMUP', url: location.href });
            })
            .catch((e) => {
                // Keep this a warning so your logger “continues as usual” (no hard errors)
                console.warn('[SW] registration error', e?.name + ': ' + e?.message);
            });
    }

    // Use load for maximum safety; keep your existing timing
    window.addEventListener('load', tryRegister, { once: true });
};
